export default "__VITE_ASSET__9wPm0d6V__"